<template>
  <div style="border: 1px solid #ccc;">
    <Toolbar
        style="border-bottom: 1px solid #ccc"
        :editor="editor"
        :defaultConfig="toolbarConfig"
        :mode="mode"
    />
    <Editor
        style="height: 500px; overflow-y: hidden;"
        v-model="html"
        :defaultConfig="editorConfig"
        :mode="mode"
        @onCreated="onCreated"
    />
  </div>
</template>
<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
  name :"wangEditor",
  components: { Editor, Toolbar },
  props:['value'],
  data (){
    return {
      editor: null,
      html: this.value,
      toolbarConfig: {
      },
      editorConfig: { placeholder: '请输入内容...',
        MENU_CONF:{
          fontSizeList: [
            // 元素支持两种形式
            //   1. 字符串；
            //   2. { name: 'xxx', value: 'xxx' }

            '12px',
            '16px',
            { name: '24px', value: '24px' },
            '40px',
          ],
          uploadImage:{
            fieldName: 'file',
            server: process.env.VUE_APP_BASE_API+ "/file/upload",
            headers: {
              Authorization: sessionStorage.getItem('token'),
            },
            maxFileSize: 100 * 1024 * 1024, // 100M
            customInsert(res, insertFn) {                  // JS 语法
              // res 即服务端的返回结果
              // 从 res 中找到 url alt href ，然后插入图片
              insertFn(res.data)
            },
          },
          insertVideo:{
            onInsertedVideo(videoNode) {                    // JS 语法
              if (videoNode == null) return

            },
        },
          uploadVideo:{
            fieldName:'file',
            server: process.env.VUE_APP_BASE_API+ "/file/upload",
            headers: {
              Authorization: sessionStorage.getItem('token'),
            },
            maxFileSize: 100 * 1024 * 1024, // 100M
            allowedFileTypes: [],
            onBeforeUpload(file) {
              return file
            },
            // onProgress(progress) {
            //
            // },
            customInsert(res, insertFn) {
              // res 即服务端的返回结果
              // 从 res 中找到 url poster ，然后插入视频
              insertFn(res.data)
            },
          },
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    haveImageorVideo(){
     let image= this.editor.getElemsByType('image') // 所有图片
      let video=this.editor.getElemsByType('video')
      return {image:image.length,video:video.length}
    }
  },

  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
